import { render, staticRenderFns } from "./InspectionIncomingDetailEdit.vue?vue&type=template&id=37240c84"
import script from "./InspectionIncomingDetailEdit.vue?vue&type=script&lang=js"
export * from "./InspectionIncomingDetailEdit.vue?vue&type=script&lang=js"
import style0 from "./InspectionIncomingDetailEdit.vue?vue&type=style&index=0&id=37240c84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports